import React from 'react';

function RadioIcon({checked = false}) {
  return (checked
    ? (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 22 22" enableBackground="new 0 0 22 22">
        <path fill="#404040" d="M11,21C5.5,21,1,16.5,1,11C1,5.5,5.5,1,11,1c5.5,0,10,4.5,10,10C21,16.5,16.5,21,11,21z M11,3 c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,3,11,3z"/>
        <path fill="#404040" d="M11,15.9c-2.7,0-4.9-2.2-4.9-4.9c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9C15.9,13.7,13.7,15.9,11,15.9 z"/>
      </svg>
    ) : (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 22 22" enableBackground="new 0 0 22 22">
        <path fill="#404040" d="M11,21C5.5,21,1,16.5,1,11C1,5.5,5.5,1,11,1c5.5,0,10,4.5,10,10C21,16.5,16.5,21,11,21z M11,3 c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,3,11,3z"/>
      </svg>
    )
  );
}

export default RadioIcon;



// WEBPACK FOOTER //
// ./src/components/icons/RadioIcon.js